<template>
  <div>
    <!-- 发布竞价商品表单页 -->
    <div class="add-goods">
      <el-form ref="form" :model="formData" :rules="rules" label-width="110px">
        <!-- ============ 基本信息 ============ -->
        <div class="title">基本信息</div>
        <div class="group info-box">
          <!-- 商品列表:每行一组(分类/名称/竞价底价/数量),可多商品竞价;增删按钮已注释停用 -->
          <div
            class="line goods-list"
            v-for="(goods, index) in formData.goodsCategoryList"
            :key="goods.key">
            <!-- 商品分类下拉(选中后加载该分类的商品指标) -->
            <el-form-item
              label="商品分类"
              label-width="110px"
              :prop="'goodsCategoryList.' + index + '.goodsType'"
              :rules="{
                required: true,
                message: '请选择商品分类',
                trigger: 'change',
              }">
              <el-select
                v-model="formData.goodsCategoryList[index].goodsType"
                @change="goodsChange($event, goods, index)"
                placeholder="请选择商品分类">
                <el-option
                  v-for="item in nameList"
                  :key="item.id"
                  :label="item.dictName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 商品名称输入 -->
            <el-form-item
              label="商品名称"
              label-width="110px"
              :prop="'goodsCategoryList.' + index + '.goodsName'"
              :rules="{
                required: true,
                message: '请输入商品名称',
                trigger: 'blur',
              }">
              <!-- <el-cascader v-model="formData.goodsName" :options="nameList" :props="{
                  value: 'id',
                  label: 'dictName',
                }" placeholder="请选择商品名称" @change="goodsChange"></el-cascader> -->
              <el-input
                v-model="formData.goodsCategoryList[index].goodsName"
                placeholder="请输入商品名称">
              </el-input>

              <!-- <el-select v-model="formData.goodsName" @change="goodsChange" placeholder="请选择商品名称">
                <el-option v-for="item in nameList" :key="item.id" :label="item.dictName" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <!-- 竞价底价(元/吨,仅数字) -->
            <el-form-item
              label="竞价底价"
              label-width="110px"
              :prop="'goodsCategoryList.' + index + '.goodsPrice'"
              :rules="{
                required: !formData.goodsCategoryList[index].checked,
                message: '请输入价格',
                trigger: 'blur',
              }">
              <el-input
                v-model="formData.goodsCategoryList[index].goodsPrice"
                placeholder="请输入竞价底价"
                maxlength="5"
                @input="formatDatas(index, 'goodsPrice')"
                :readonly="formData.checked">
                <template slot="append">元/吨</template>
              </el-input>
            </el-form-item>
            <!-- 数量(吨,仅整数) -->
            <el-form-item
              label="数量"
              label-width="110px"
              :prop="'goodsCategoryList.' + index + '.number'"
              :rules="{
                required: true,
                message: '请输入数量',
                trigger: 'blur',
              }">
              <el-input
                class="number"
                v-model.trim="formData.goodsCategoryList[index].number"
                placeholder="请输入数量"
                @input="formatDatas(index, 'number')"
                maxlength="7"
                min="1">
                <template slot="append">吨</template>
              </el-input>
            </el-form-item>
            <!-- <el-button
              v-if="goods.key == 0"
              style="margin-left: 10px"
              @click="addGoodes()"
              >增加</el-button
            >
            <el-button
              v-if="goods.key != 0"
              style="margin-left: 10px"
              @click="delGoods(goods)"
              >删除</el-button
            > -->
          </div>
          <!-- <div class="line"></div> -->
          <!-- 配送方式 + 支付方式 -->
          <div class="line col2" style="margin-top: 10px">
            <el-form-item label="配送方式" label-width="110px" prop="deliveryMode">
              <el-select
                v-model="formData.deliveryMode"
                placeholder="请选择配送方式"
                @change="selectChange('deliveryMode')">
                <el-option
                  v-for="item in deliveryMode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式" label-width="110px" prop="payType">
              <el-select
                v-model="formData.payType"
                placeholder="请选择支付方式"
                @change="selectChange('payType')">
                <el-option
                  v-for="item in payType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 保证金(万元,不可为 0) + 价格类型(含税/不含税 + 坑口价等) -->
          <div class="line col2">
            <el-form-item label="保证金" label-width="110px" prop="bond">
              <el-input
                v-model="formData.bond"
                placeholder="请输入保证金"
                @input="formatData('bond')"
                @blur="vaildZero('bond')">
                <template slot="append">万元</template>
              </el-input>
            </el-form-item>

            <div class="pirceType">
              <el-form-item label="价格类型" label-width="110px" prop="taxIncluded">
                <el-select
                  v-model="formData.taxIncluded"
                  placeholder="是否含税"
                  @change="selectChange('taxIncluded')">
                  <el-option label="含税" :value="0"></el-option>
                  <el-option label="不含税" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="priceType" label-width="0">
                <el-select
                  v-model="formData.priceType"
                  placeholder="请选择类型"
                  @change="selectChange('priceType')">
                  <el-option
                    v-for="item in priceTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- <el-form-item label="商品分类" prop="goodsType">
              <el-select
                v-model="formData.goodsType"
                @change="goodsChange"
                placeholder="请选择商品分类"
              >
                <el-option
                  v-for="item in nameList"
                  :key="item.id"
                  :label="item.dictName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
          </div>
          <div class="line col2">
            <el-form-item class="normal" label="是否定向竞价" prop="biddingTargeted">
              <div class="radio-group">
                <el-radio v-model="formData.biddingTargeted" :label="1"> 是 </el-radio>
                <el-radio v-model="formData.biddingTargeted" :label="0"> 否 </el-radio>
              </div>
            </el-form-item>
            <el-form-item label="交货期限" label-width="110px" prop="deliveryPeriod">
              <el-input
                v-model="formData.deliveryPeriod"
                placeholder="请输入交货期限"
                @input="formatData('deliveryPeriod')">
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="line col2">
            <el-form-item class="normal" label="是否需要审核后参与竞价" prop="partNeedAudit">
              <div class="radio-group">
                <el-radio v-model="formData.partNeedAudit" :label="1"> 是 </el-radio>
                <el-radio v-model="formData.partNeedAudit" :label="0"> 否 </el-radio>
              </div>
            </el-form-item>
          </div>
          <div class="line col2" style="margin-top: 10px">
            <el-form-item class="normal" label="是否配置最低参与人数" prop="ifMinNumber">
              <div class="radio-group">
                <el-radio v-model="formData.ifMinNumber" :label="1" @input="handleIfMinNumber">
                  是
                </el-radio>
                <el-radio v-model="formData.ifMinNumber" :label="0" @input="handleIfMinNumber">
                  否
                </el-radio>
              </div>
            </el-form-item>
            <el-form-item
              label="最低参与人数"
              label-width="110px"
              prop="minNumber"
              v-if="formData.ifMinNumber == 1">
              <el-input
                v-model="formData.minNumber"
                placeholder="请输入最低参与人数"
                @input="formatData('minNumber')">
              </el-input>
            </el-form-item>
          </div>

          <!-- 是否延迟竞价 -->
          <div class="line col2">
            <el-form-item class="normal" label="是否延迟竞价" prop="biddingExtension">
              <div class="radio-group">
                <el-radio v-model="formData.biddingExtension" :label="1"> 是 </el-radio>
                <el-radio v-model="formData.biddingExtension" :label="0"> 否 </el-radio>
              </div>
            </el-form-item>
          </div>

          <!-- 各商品指标动态表单(按所选分类生成,必填项由字典 ifMust 决定) -->
          <div v-for="(goods, goodsIndex) in formData.goodsCategoryList" :key="'goods' + goods.key">
            <div class="quotaList-box" v-if="goods.quotaList.length > 0">
              <h3>{{ goods.dictName }}商品指标</h3>
              <div class="list">
                <div class="quota-item" v-for="(item, index) in goods.quotaList" :key="item.id">
                  <el-form-item
                    :label="item.dictName"
                    label-width="140px"
                    :prop="
                      'goodsCategoryList.' + goodsIndex + '.quotaList.' + index + '.quotaValue'
                    "
                    :rules="{
                      required: item.ifMust == 0,
                      message: item.dictName + '不能为空',
                      trigger: 'blur',
                    }">
                    <el-input
                      v-model.trim="item.quotaValue"
                      :placeholder="`请输入${item.dictName}`"
                      @input="formatFloat(goodsIndex, index, 'quotaValue')">
                      <template slot="append" v-if="item.dictValue">{{ item.dictValue }}</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="quotaList-box" v-if="formData.quotaList.length > 0">
            <h3>商品指标</h3>
            <div class="list">
              <div
                class="quota-item"
                v-for="(item, index) in formData.quotaList"
                :key="item.id"
              >
                <el-form-item
                  :label="item.dictName"
                  label-width="110px"
                  :prop="'quotaList.' + index + '.quotaValue'"
                  :rules="{
                    required: true,
                    message: item.dictName + '不能为空',
                    trigger: 'blur',
                  }"
                >
                  <el-input
                    v-model="item.quotaValue"
                    :placeholder="`请输入${item.dictName}`"
                    @input="formatFloat(index, 'quotaValue')"
                  >
                    <template slot="append" v-if="item.dictValue">{{
                      item.dictValue
                    }}</template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div> -->
          <!-- 备注说明 -->
          <div class="textarea-box">
            <el-form-item label="备注说明" prop="">
              <el-input
                type="textarea"
                v-model="formData.remark"
                :rows="3"
                maxlength="10000"
                placeholder="请输入备注"></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- ============ 其他信息 ============ -->
        <div class="title">其他信息</div>
        <div class="group">
          <!-- 交割地(省市区级联) + 详细地址 -->
          <div class="line adress">
            <el-form-item label="交割地" prop="deliveryPlace">
              <el-cascader
                v-model="formData.deliveryPlace"
                @change="selectChange('deliveryPlace')"
                :options="citys"
                placeholder="请选择交割地"
                :props="{
                  value: 'name',
                  label: 'name',
                  checkStrictly: true,
                }"></el-cascader>
            </el-form-item>
            <el-form-item label="交割地详细地址" prop="deliveryPlaceDetail">
              <el-input
                v-model.trim="formData.deliveryPlaceDetail"
                placeholder="请输入交割地详细地址"
                maxlength="100"></el-input>
            </el-form-item>
          </div>
          <!-- 产地(省市区级联) + 详细地址 -->
          <div class="line adress">
            <el-form-item label="产地" prop="originPlace">
              <el-cascader
                v-model="formData.originPlace"
                :options="citys"
                placeholder="请选择产地"
                @change="selectChange('originPlace')"
                :props="{
                  value: 'name',
                  label: 'name',
                  checkStrictly: true,
                }"></el-cascader>
            </el-form-item>
            <el-form-item label="产地详细地址" prop="originPlaceDetail">
              <el-input
                v-model.trim="formData.originPlaceDetail"
                placeholder="请输入产地详细地址"
                maxlength="100"></el-input>
            </el-form-item>
          </div>
          <!-- 企业名称 / 联系人 / 联系方式 -->
          <div class="line line3">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input
                v-model.trim="formData.enterpriseName"
                placeholder="请输入企业名称"
                maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input
                v-model.trim="formData.contacts"
                placeholder="请输入联系人"
                maxlength="20"></el-input>
            </el-form-item>
            <el-form-item
              label="联系方式"
              prop="contactInfo"
              class="contactInfo"
              label-width="90px">
              <el-input
                v-model.trim="formData.contactInfo"
                placeholder="请输入联系方式"
                maxlength="11"
                @input="formatData('contactInfo')"></el-input>
            </el-form-item>
          </div>
          <!-- 竞价须知 -->
          <div class="textarea-box">
            <el-form-item label="竞价须知" prop="biddingNotice">
              <el-input
                type="textarea"
                v-model="formData.biddingNotice"
                :rows="3"
                maxlength="5000"
                placeholder="请输入竞价须知"></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- ============ 竞价设置 ============ -->
        <div class="title">竞价设置</div>
        <div class="group">
          <!-- 开始时间 / 结束时间(至少间隔 5 分钟) / 最低加价(采购单显示"最低降价") -->
          <div class="line line3">
            <el-form-item label="开始时间" prop="biddingStartTime">
              <el-date-picker
                v-model="formData.biddingStartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择竞价开始时间"
                @change="handleTimeChange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="biddingEndTime">
              <el-date-picker
                v-model="formData.biddingEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择竞价结束时间"
                @change="handleTimeChange">
              </el-date-picker>
            </el-form-item>
            <el-form-item
              :label="$route.query.selectOrderType == 1 ? '最低加价' : '最低降价'"
              prop="lowestDiffPrice"
              class="contactInfo"
              label-width="90px">
              <el-input
                v-model="formData.lowestDiffPrice"
                :placeholder="
                  $route.query.selectOrderType == 2 && $route.query.selectTradeType == 2
                    ? '报价最小降价数值，正整数'
                    : '报价最小加价数值，正整数'
                "
                maxlength="3"
                @input="formatData('lowestDiffPrice')"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="line">
            <el-form-item label="交割开始时间" prop="deliveryStartTime">
              <el-date-picker
                v-model="formData.deliveryStartTime"
                type="datetime"
                placeholder="请选择交割开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="交割结束时间" prop="deliveryEndTime">
              <el-date-picker
                v-model="formData.deliveryEndTime"
                type="datetime"
                placeholder="请选择交割结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </div> -->
          <!-- 竞价设置项勾选(字典 bidding_set) + 自动判定规则说明(销售取最高价/采购取最低价中标) -->
          <div class="checke-box">
            <div class="checke-item" v-for="item in formData.setList" :key="item.id">
              <el-checkbox v-model="item.checked" :true-label="1" :false-label="0">{{
                item.dictName
              }}</el-checkbox>
              <p class="tip">※{{ item.dictValue || "." }}</p>
            </div>
            <div class="checke-item">
              <h6><i class="hy-icon-icon"></i>自动判定</h6>
              <p class="tip">
                ※系统自动判断最{{
                  $route.query.selectOrderType == 1 ? "高" : "低"
                }}价者中标(多个商品竞价是价格相加报价最{{
                  $route.query.selectOrderType == 1 ? "高" : "低"
                }}者中标),{{
                  $route.query.selectOrderType == 1
                    ? "当最高价相同时,最先报价者中标"
                    : "当最低价相同时,最先报价者中标"
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- 提交:立即发布 -->
        <div class="btn-wrap">
          <el-button type="primary" @click="submit" class="hy-btn">立即发布</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { reqDictType, reqAddBiddingGoods } from "@/api/hy";
import { tradeDtetails } from "@/api/public.js";
// import citys from "@/assets/json/citys";
import { getTreeV2 } from "@/api/Medium.js";
import moment from "moment";
export default {
  data() {
    /** 联系人自定义校验:2-20 位汉字 */
    const validateContacts = (rule, value, callback) => {
      let validate = /^[\u4e00-\u9fa5·]{2,20}$/;
      if (!validate.test(value)) {
        return callback(new Error("名称只能输入2-20位汉字"));
      } else {
        return callback();
      }
    };
    /** 结束时间校验:不得早于等于开始时间,且至少间隔 5 分钟 */
    const validateTimeDiff = (rule, value, callback) => {
      if (!this.formData.biddingStartTime || !this.formData.biddingEndTime) {
        callback();
        return;
      }

      const startMoment = moment(this.formData.biddingStartTime);
      const endMoment = moment(this.formData.biddingEndTime);
      const diffMinutes = endMoment.diff(startMoment, "minutes");

      if (diffMinutes < 5 && diffMinutes > 0) {
        return callback(new Error("结束时间与开始时间至少间隔5分钟"));
      } else if (diffMinutes <= 0) {
        return callback(new Error("结束时间不能早于等于开始时间"));
      } else {
        return callback();
      }
    };
    return {
      /** 省市区级联数据(交割地/产地共用) */
      citys: [],
      /** 表单数据 */
      formData: {
        /** 初始总量(当前表单未使用) */
        initialCount: "",
        /** 是否含税:0 含税,1 不含税 */
        taxIncluded: "",
        /** 价格类型:1 坑口价 ~ 6 到厂价 */
        priceType: "",
        /** 底价(当前表单未使用,底价挂在商品行) */
        floorPrice: "",
        /** 保证金(万元) */
        bond: "",
        /** 备注说明 */
        remark: "",
        /** 支付方式:1 现金,2 承兑,3 现金+承兑 */
        payType: "",
        /** 交割地(省市区数组) */
        deliveryPlace: "",
        /** 交割地详细地址 */
        deliveryPlaceDetail: "",
        /** 产地(省市区数组) */
        originPlace: "",
        /** 产地详细地址 */
        originPlaceDetail: "",
        /** 企业名称 */
        enterpriseName: "",
        /** 联系人 */
        contacts: "",
        /** 交货期限(天) */
        deliveryPeriod: "",
        /** 联系方式 */
        contactInfo: "",
        /** 竞价须知 */
        biddingNotice: "",
        /** 竞价开始时间 */
        biddingStartTime: "",
        /** 竞价结束时间 */
        biddingEndTime: "",
        /** 最低加/降价幅度 */
        lowestDiffPrice: "",
        /** 是否定向竞价:0 否,1 是 */
        biddingTargeted: 0,
        /** 是否需审核后参与竞价:0 否,1 是 */
        partNeedAudit: 0,
        /** 最低参与人数(ifMinNumber=1 时必填) */
        minNumber: "",
        /** 指标列表(当前表单未使用,指标挂在商品行内) */
        quotaList: [],
        /** 交易类型:固定 2 竞价 */
        tradeType: 2,
        /** 订单类型:1 销售,2 采购(mounted 中由路由覆盖) */
        orderType: 1,
        /** 商品类型(当前表单未使用,类型挂在商品行内) */
        goodsType: "",
        /** 竞价设置项勾选列表(字典 bidding_set) */
        setList: [],
        /** 配送方式:1 送货,2 自提 */
        deliveryMode: "",
        /** 是否配置最低参与人数:0 否,1 是 */
        ifMinNumber: 0,
        /** 是否延迟竞价:0 否,1 是 */
        biddingExtension: 0,
        /** 商品列表(多商品竞价时多行,指标 quotaList 挂在行内) */
        goodsCategoryList: [
          {
            goodsName: "", //商品名称
            goodsType: "", //商品类型
            goodsPrice: "", //商品价格
            key: 0, //key
            number: "", //数量
            quotaList: [], //指标列表
            checked: false, //价格是否面议
          },
        ],
      },
      /** 表单校验规则 */
      rules: {
        biddingTargeted: [
          {
            required: true,
            message: "请选择是否定向竞价",
            trigger: "change",
          },
        ],
        partNeedAudit: [
          {
            required: true,
            message: "请选择商品是否需要审核",
            trigger: "change",
          },
        ],
        biddingExtension: [
          {
            required: true,
            message: "请选择是否延迟竞价",
            trigger: "change",
          },
        ],
        ifMinNumber: [
          {
            required: true,
            message: "请选择是否配置最低参与人数",
            trigger: "change",
          },
        ],
        minNumber: [{ required: true, message: "请输入最低参与人数", trigger: "blur" }],
        deliveryPeriod: [{ required: true, message: "请输入交货期限", trigger: "blur" }],
        goodsName: [{ required: true, message: "请输入商品名称", trigger: "change" }],
        goodsType: [{ required: true, message: "请选择商品类别", trigger: "blur" }],
        initialCount: [{ required: true, message: "请输入总量", trigger: "blur" }],
        taxIncluded: [{ required: true, message: "请选择价格类型", trigger: "blur" }],
        priceType: [{ required: true, message: "请选择价格类型", trigger: "blur" }],
        payType: [{ required: true, message: "请选择支付方式", trigger: "blur" }],
        deliveryMode: [{ required: true, message: "请选择配送方式", trigger: "blur" }],
        floorPrice: [{ required: true, message: "请输入竞价底价", trigger: "blur" }],
        bond: [{ required: true, message: "请输入保证金", trigger: "blur" }],
        deliveryPlace: [{ required: true, message: "请选择交割地", trigger: "blur" }],
        // deliveryPlaceDetail: [
        //   { required: true, message: "请输入交割地详细地址", trigger: "blur" },
        // ],
        originPlace: [{ required: true, message: "请选择产地", trigger: "blur" }],
        // originPlaceDetail: [
        //   { required: true, message: "请输入产地详细地址", trigger: "blur" },
        // ],
        enterpriseName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { validator: validateContacts, trigger: "blur" },
        ],
        contactInfo: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        biddingStartTime: [{ required: true, message: "请选择开始日期", trigger: "blur" }],
        biddingEndTime: [
          { required: true, message: "请选择结束日期", trigger: "blur" },
          { validator: validateTimeDiff, trigger: "blur" },
        ],
        lowestDiffPrice: [{ required: true, message: "请输入最低加价", trigger: "blur" }],
        // deliveryStartTime: [
        //   { required: true, message: "请选择交割开始日期", trigger: "blur" },
        // ],
        // deliveryEndTime: [
        //   { required: true, message: "请选择交割结束日期", trigger: "blur" },
        // ],
        // deliveryPlaceDetail:[
        //   { required: true, message: "请输入交割地详细地址", trigger: "blur" },
        // ],
        // originPlaceDetail: [
        //   { required: true, message: "请输入产地地详细地址", trigger: "blur" },
        // ]
      },
      /** 商品名称列表(未使用) */
      goodsNameList: [],
      /** 指标列表(未使用) */
      normList: [],
      /** 价格类型选项 */
      priceTypeList: [
        { value: 1, label: "坑口价" },
        { value: 2, label: "出厂价" },
        { value: 3, label: "到港价" },
        { value: 4, label: "平仓价" },
        { value: 5, label: "车板价" },
        { value: 6, label: "到厂价" },
      ],
      /** 支付方式选项 */
      payType: [
        { value: 1, label: "现金" },
        { value: 2, label: "承兑" },
        { value: 3, label: "现金+承兑" },
      ],
      /** 配送方式选项 */
      deliveryMode: [
        { value: 1, label: "送货" },
        { value: 2, label: "自提" },
      ],
      /** 商品分类选项(下拉用,已去除三级 children) */
      nameList: [],
      /** 商品分类字典全量(含指标 children,供 goodsChange 用) */
      dictList: [],
      /** 未使用 */
      checked: "",
      /** 测试残留(未使用) */
      aaaa: {
        b: 1,
      },
    };
  },
  /** 初始化:从 localStorage 回填企业名称与联系方式 */
  created() {
    // this.formData.contacts = window.localStorage.getItem("userName");
    this.formData.enterpriseName = localStorage.getItem("userName");
    this.formData.contactInfo = window.localStorage.getItem("phone");
  },
  /** 初始化:再发布时回填原单;加载省市区、路由订单类型、商品分类、竞价设置项 */
  mounted() {
    if (this.$route.query.order == 1) {
      this.getorder();
    }
    // this.citys = citys.filter(item => item.value == '650100')
    this.getTree();
    let routeQuery = this.$route.query;
    this.formData.orderType = routeQuery.selectOrderType;
    this.getGoodsName();
    this.getSetList();
  },
  methods: {
    /** 再发布:拉取原竞价单详情并整体回填表单(含商品行、指标、竞价设置项) */
    getorder() {
      tradeDtetails(this.$route.query.goodsId).then(res => {
        if (res.code == 0) {
          let data = res.data;
          // 步骤一:按分类匹配回填商品行与指标列表
          let newdata = this.dictList.find(item => {
            if (item.id == data.goodsCategoryList[0].goodsType) {
              return item;
            }
          });
          let headedata = JSON.stringify(newdata.children);
          let a = data.goodsCategoryList[0].quotas;
          let newArr = [];
          JSON.parse(headedata).forEach(item => {
            a.forEach(item1 => {
              if (item.dictName == item1.name) {
                item.quotaValue = item1.value;
                newArr.push(item);
              }
            });
          });
          newArr.map(item2 => {
            return {
              dictName: item2.dictName,
              dictRemark: item2.dictRemark,
              dictType: item2.dictType,
              dictValue: item2.dictValue,
              id: item2.id,
              ifMust: item2.ifMust,
              parentId: item2.parentId,
              sort: item2.sort,
              quotaValue: item2.value,
            };
          });

          data.goodsCategoryList[0].quotaList = newArr;
          // this.formData = data;
          // 步骤二:回填配送/支付/保证金/价格类型/审核/交货期限/延迟竞价
          this.formData.goodsCategoryList = data.goodsCategoryList;
          this.formData.deliveryMode = data.tradeGoods.deliveryMode;
          this.formData.payType = data.tradeGoods.payType;
          this.formData.bond = data.tradeBidding.bond;
          this.formData.taxIncluded = data.tradeBidding.taxIncluded;
          this.formData.priceType = data.tradeBidding.priceType;
          this.formData.partNeedAudit = data.tradeBidding.partNeedAudit;
          this.formData.deliveryPeriod = data.tradeBidding.deliveryPeriod;
          this.formData.biddingExtension = data.tradeBidding.biddingExtension;
          // 步骤三:回填交割地与产地(省市区数组需剔除混入的详细地址)
          let Plce = data.tradeGoods.deliveryPlace.split(",");
          /** 省市区字段包含详细地址，需要剔除 */
          if (data.tradeGoods.deliveryPlaceDetail) Plce.pop();
          this.formData.deliveryPlace = Plce;
          this.formData.deliveryPlaceDetail = data.tradeGoods.deliveryPlaceDetail;
          let OPlace = data.tradeGoods.originPlace.split(",");
          if (data.tradeGoods.originPlaceDetail) OPlace.pop();
          this.formData.originPlace = OPlace;
          this.formData.originPlaceDetail = data.tradeGoods.originPlaceDetail;
          // 步骤四:回填联系人/须知/起止时间/最低价差
          this.formData.contactInfo = data.tradeGoods.contactInfo;
          this.formData.enterpriseName = data.tradeGoods.enterpriseName;
          this.formData.contacts = data.tradeGoods.contacts;
          this.formData.biddingNotice = data.tradeBidding.biddingNotice;
          this.formData.biddingStartTime = data.tradeBidding.createTime.replace("T", " ");
          this.formData.biddingEndTime = data.tradeBidding.endTime.replace("T", " ");
          this.formData.lowestDiffPrice = data.tradeBidding.lowestDiffPrice;
          // 步骤五:拉取竞价设置项
          console.log("this.formData", this.formData);
          reqDictType({ dictType: "bidding_set" })
            .then(ret => {
              if (ret.code == 0) {
                this.formData.setList = ret.data.children;
                console.log(this.formData.setList, "-----this.setList----");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    /** 切换"是否配置最低参与人数":选否时清空最低人数 */
    handleIfMinNumber() {
      if (this.formData.ifMinNumber == 0) {
        this.formData.minNumber = "";
      }
    },
    /** 删除商品行(当前模板已停用增删按钮) */
    delGoods(goods) {
      this.formData.goodsCategoryList = this.formData.goodsCategoryList.filter(
        item => item.key != goods.key,
      );
    },
    /** 新增商品行,上限 5 个(当前模板已停用) */
    addGoodes() {
      if (this.formData.goodsCategoryList.length >= 5) {
        this.$message.error("数量超出限制");
        return;
      }
      this.formData.goodsCategoryList.push({
        goodsType: "",
        goodsName: "",
        goodsPrice: "",
        number: "", //数量
        key: this.formData.goodsCategoryList[this.formData.goodsCategoryList.length - 1].key + 1,
        quotaList: [],
        checked: false,
      });
      console.log(this.formData.goodsCategoryList);
    },
    /** 获取省市区树并清理空节点 */
    getTree() {
      getTreeV2().then(res => {
        if (res.code == 0) {
          this.citys = this.deleteChildren(res.data);
        }
      });
    },
    /** 递归删除树形数据的空 children 节点 */
    deleteChildren(arr) {
      let childs = arr;
      for (let i = childs.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children.length) {
            this.deleteChildren(childs[i].children);
          } else {
            delete childs[i].children;
          }
        }
      }
      return arr;
    },
    /** 指标输入格式化:仅数字,最多 2 位小数(整数最长 20 位) */
    formatFloat(goodsIndex, index, name) {
      this.formData.goodsCategoryList[goodsIndex].quotaList[index][name] =
        this.formData.goodsCategoryList[goodsIndex].quotaList[index][name].match(
          /^\d*(\.?\d{0,23})/g,
        )[0] || "";
      if (this.formData.goodsCategoryList[goodsIndex].quotaList[index][name].indexOf(".") > 0) {
        this.formData.goodsCategoryList[goodsIndex].quotaList[index][name] =
          this.formData.goodsCategoryList[goodsIndex].quotaList[index][name].substring(
            0,
            this.formData.goodsCategoryList[goodsIndex].quotaList[index][name].indexOf(".") + 3,
          );
      } else {
        this.formData.goodsCategoryList[goodsIndex].quotaList[index][name] =
          this.formData.goodsCategoryList[goodsIndex].quotaList[index][name].substring(0, 20);
      }
    },
    /** 选择器变化后清除对应字段的校验提示 */
    selectChange(name) {
      this.$refs.form.clearValidate(name);
    },
    /** 获取竞价设置项字典(bidding_set) */
    getSetList() {
      reqDictType({ dictType: "bidding_set" })
        .then(ret => {
          if (ret.code == 0) {
            this.formData.setList = ret.data.children;
            console.log(this.setList, "-----this.setList----");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /** 商品分类切换:按分类加载指标列表并重置指标值 */
    goodsChange(e, obj, index) {
      outer: for (let i = 0; i < this.dictList.length; i++) {
        let item = this.dictList[i];
        // if (item.id == e) {
        //   item.children.forEach((items) => {
        //     this.$set(items, "quotaValue", "");
        //   });
        //   obj.dictName = item.dictName
        //   this.goodsName = item.dictName;
        //   obj.quotaList = item.children.map((item) => {
        //     let arr = item.dictValue.split(";");
        //     return {
        //       ...item,
        //       dictName: item.dictName + "(" + arr[0] + ")" + arr[2],
        //       dictValue: arr[1],
        //     };
        //   });
        //   console.log(this.formData.quotaList);
        //   break outer;
        // }
        if (item.id == e) {
          item.children.forEach(items => {
            this.$set(items, "quotaValue", "");
          });
          console.log(item);
          obj.dictName = item.dictName;
          this.goodsName = item.dictName;
          obj.quotaList = item.children.map(item => {
            let arr = item.dictValue.split(";");
            return {
              ...item,
              dictName: item.dictName + "(" + arr[0] + ")" + arr[2],
              dictValue: arr[1],
            };
          });
          break outer;
        }
      }
      if (e.length > 0) {
        this.$refs.form.clearValidate("goodsInfo.goodsCategoryList." + index + ".goodsName");
      }
    },
    /** 值为 0 时清空(用于保证金失焦校验) */
    vaildZero(name) {
      if (this.formData[name] == 0) {
        this.formData[name] = "";
      }
    },
    /** 表单字段输入格式化:保证金允许 2 位小数(整数 3 位),其余仅整数且 0 清空 */
    formatData(name) {
      if (name == "bond") {
        this.formData[name] = this.formData[name].match(/^\d*(\.?\d{0,2})/g)[0] || "";
        if (this.formData[name].indexOf(".") > 0) {
          this.formData[name] =
            this.formData[name].split(".")[0].slice(0, 3) +
              "." +
              this.formData[name].split(".")[1] || "";
        } else {
          this.formData[name] = this.formData[name].match(/^\d*/g)[0].slice(0, 3) || "";
        }
      } else {
        this.formData[name] = this.formData[name].match(/^\d*/g)[0] || "";
        if (this.formData[name] == 0) {
          this.formData[name] = "";
        }
      }
    },
    /** 商品行字段输入格式化:仅整数,0 清空 */
    formatDatas(index, key) {
      this.formData["goodsCategoryList"][index][key] =
        this.formData["goodsCategoryList"][index][key].match(/^\d*/g)[0] || "";
      if (this.formData["goodsCategoryList"][index][key] == 0) {
        this.formData["goodsCategoryList"][index][key] = "";
      }
    },
    /** 获取商品分类字典:全量存 dictList,去除三级 children 后存 nameList 供下拉 */
    getGoodsName() {
      reqDictType({ dictType: "coal_type" })
        .then(ret => {
          if (ret.code == 0) {
            this.dictList = JSON.parse(JSON.stringify(ret.data.children));
            let data = ret.data.children;
            console.log(data, "datadatadatadata");
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              for (let j = 0; j < item.children.length; j++) {
                let sub = item.children[j];
                delete sub.children;
              }
            }
            this.nameList = data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /** 开始/结束时间改变:重新触发结束时间校验 */
    handleTimeChange() {
      this.$refs.form && this.$refs.form.validateField("biddingEndTime");
    },
    /** 提交入口:整体表单校验通过后执行发布 */
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // if(this.formData.initialCount==0||this.formData.floorPrice==0||this.formData.bond==0) return this.$message.error('产品总量,竞价底价,保证金都不能为零')
          this.submitFn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 组装提交数据:交割地/产地数组拼接、指标与商品行精简、设置项转 setId/setValue */
    initSubmitData() {
      let data = {
        ...this.formData,
      };
      // data.goodsType = data.goodsName;
      // 步骤一:交割地/产地数组转逗号字符串
      if (Array.isArray(data.deliveryPlace)) {
        data.deliveryPlace = data.deliveryPlace.join(",");
      }
      if (Array.isArray(data.originPlace)) {
        data.originPlace = data.originPlace.join(",");
      }
      // data.goodsName = this.goodsName;
      // 步骤二:指标精简为 quotaId + quotaValue
      data.goodsCategoryList.forEach(item => {
        item.quotaList = item.quotaList.map(quota => {
          return {
            quotaId: quota.id || quota.quotaId,
            quotaValue: quota.quotaValue,
          };
        });
      });
      // 步骤三:商品行仅保留提交字段
      data.goodsCategoryList = data.goodsCategoryList.map(item => {
        return {
          goodsName: item.goodsName,
          goodsPrice: item.goodsPrice,
          goodsType: item.goodsType,
          quotaList: item.quotaList,
          number: item.number,
        };
      });
      // 步骤四:设置项转 setId + setValue
      data.setList = data.setList.map(item => {
        return {
          setId: item.id,
          setValue: !item.checked ? 0 : 1,
        };
      });
      // data.bond = data.bond * 10000;
      return data;
    },
    /** 发布:防重复提交,成功后提示"等待平台审核"并返回上一页 */
    submitFn() {
      // 步骤一:防重复提交并组装数据
      if (this.submiting) return;
      this.submiting = true;
      let data = this.initSubmitData();
      console.log(data, "6666666666666");
      // 步骤二:调发布接口,成功提示"等待平台审核"并返回上一页
      reqAddBiddingGoods(data)
        .then(ret => {
          if (ret.code == 0) {
            this.$confirm("发布成功,请等待平台审核", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "关闭",
              cancelButtonClass: "hy-confirm-cancel-btn",
              type: "warning",
              customClass: "hy-confirm",
              iconClass: "hy-icon-jingjia",
            })
              .then(() => {
                this.$router.go(-1);
              })
              .catch(() => {
                this.$router.go(-1);
              });
          } else {
            this.$message({
              type: "error",
              message: ret.message,
            });
          }
          this.submiting = false;
        })
        .catch(err => {
          this.submiting = false;
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-goods {
  width: 1195px !important;
  margin: 14px auto !important;
  background: white !important;
  border: 1px solid #e5e5e5 !important;
  border-top: none !important;

  &::before,
  &::after {
    display: table !important;
    content: "" !important;
  }
}

.title {
  font-size: 18px !important;
  font-weight: bold !important;
  font-family: PingFang SC !important;
  padding: 14px 15px !important;
  border: 1px solid #e5e5e5 !important;
  border-left: none !important;
  border-right: none !important;
  background: #f7f7f7 !important;
  display: flex !important;
  align-items: center !important;
}

.btn-wrap {
  text-align: center !important;
  margin-bottom: 35px !important;

  .hy-btn {
    width: 193px !important;
  }
}

.floorPrice,
.bond {
  .el-input {
    width: 276px !important;
  }
}

.listingPrice .el-checkbox {
  margin-left: 20px !important;
}

.textarea-box {
  width: 100% !important;
}

.quotaList-box {
  h3 {
    font-size: 14px !important;
    color: #606266 !important;
    line-height: 40px !important;
    font-weight: normal !important;
    width: 140px !important;
    text-align: right !important;
    padding-right: 12px !important;
  }

  .list {
    display: flex !important;
    align-items: center !important;
    flex-wrap: wrap !important;

    .quota-item {
      width: 50% !important;
      flex-shrink: 0 !important;
    }
  }
}

.group {
  padding: 32px 39px !important;
  background: white !important;
}

.line {
  display: flex !important;
  align-items: flex-start !important;

  .el-input,
  .el-select,
  .el-cascader {
    width: 275px !important;
  }
}
.normal {
  ::v-deep .el-form-item__label {
    line-height: normal !important;
  }
}
.goods-list {
  flex-wrap: wrap;
  background-color: #f5f5f5;
  padding-top: 20px;
  margin-top: 10px;
  &:nth-child(1) {
    margin-top: 0;
  }
  .el-input,
  .el-select,
  .el-cascader {
    width: 413px !important;
  }
  .number {
    width: 333px !important;
  }
}
.col2 {
  .radio-group,
  .el-input,
  .el-select,
  .el-cascader {
    width: 413px !important;
  }
}

.adress {
  .el-form-item:nth-child(2) {
    .el-input {
      width: 564px !important;
    }
  }
}

.line3 .contactInfo {
  .el-input {
    width: 200px !important;
  }
}

.pirceType {
  display: flex !important;
  align-items: center !important;

  .el-select,
  .el-input {
    width: 137.5px !important;
  }
}

.checke-box {
  display: flex !important;
  // align-items: center !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
  padding: 0 35px !important;

  .checke-item {
    width: 494px !important;
    border-bottom: 1px dashed #e5e5e5 !important;
    padding-bottom: 10px !important;
    margin-bottom: 20px !important;

    &::v-deep .el-checkbox__label {
      color: #2079fb;
      font-family: FZLanTingHei-R-GBK;
    }

    h6 {
      color: #2079fb;
      font-weight: normal;
      font-family: FZLanTingHei-R-GBK;

      i {
        color: #2079fb;
        margin-right: 10px;
      }
    }

    p {
      line-height: 30px !important;
    }

    .tip {
      color: #fb4d4d;
      font-family: FZLanTingHei-R-GBK;
      font-size: 12px;
      padding-left: 25px;
    }
  }
}
</style>
